import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _en = {
    weekdays: ["undefined", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    weekdays_abbr: ["undefined", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    months_abbr: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
};

export type I18nCalendar = typeof _en;

const _fr: I18nCalendar = {
    weekdays: ["undefined", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
    weekdays_abbr: ["undefined", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"],
    months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
    months_abbr: ["Jan", "Fev", "Mars", "Avr", "Mai", "Juin", "Juil", "Aou", "Sep", "Oct", "Nov", "Dec"]
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18n(lang?: string): I18nCalendar {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}